import { useQuery } from 'react-query';

import { AuditTrail } from '../../../../backend/src/auditTrail/auditTrail.entity';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';

// Fetches the user's recent activity for a matter, or for a subset if `subsetId` is passed.
export function useGetRecentActivity(matterId: string, subsetId?: string) {
  const fetcher = useFetcher();

  return useQuery<AuditTrail[]>(
    [QueryEntity.RecentActivity, { matterId, subsetId }],
    () => {
      const query = subsetId !== undefined ? `?subsetId=${subsetId}` : '';
      return fetcher(`${APIBaseChronos}/api/matter/${matterId}/recent-activity${query}`);
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!matterId,
    },
  );
}
